import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import classNames from "classnames";
import { signOut, finishOnboarding } from "../../user/actions";
import { resolveNotifications } from "../../trustpass/actions";
import { fetchPersonalTrustpasses, submitPersonalTrustpass } from "../../trustpass/personalTrustpassActions";
import { fetchBusinessTrustpasses, submitBusinessTrustpass } from "../../trustpass/businessTrustpassActions";
import { fetchFinancialTrustpass, submitFinancialTrustpass } from "../../financial-trustpass/actions";

import Layout from "../../shared/components/layouts/MainLayout";
import PTPRequirements from "../components/PTPRequirements";
import BTPRequirements from "../components/BTPRequirements";
import { segmentEventTracker } from "../../../utils/SegmentEventTracker";
import {PageViewName, TrackEventName} from "../../shared/constants/SegmentEvents";

export class Requirements extends Component {
  componentDidMount() {
    this.trackPageView();
    this.props.fetchPersonalTrustpasses(this.props.user.id);
    this.props.fetchBusinessTrustpasses(this.props.user.id);
    this.props.fetchFinancialTrustpass(this.props.user.id);
  }

  incompletePtp = () => {
    const ptp = this.props.personalTrustPass;

    return ptp.information_status === 'draft';
  }

  incompleteBtp = () => {
    const btp = this.props.businessTrustPass;

    return btp.information_status === 'draft';
  }

  onPTPSubmit = () => {
    segmentEventTracker.trackEvent(TrackEventName.SUBMIT_FOR_VERIFICATION_PERSONAL_CLICKED)
    if(this.incompletePtp()) return;
    this.props.resolveNotifications('ptp', this.props.personalTrustPass.id);
    this.props.submitPersonalTrustpass(
      this.props.user.id,
      this.props.personalTrustPass.id
    );
  }

  onBTPSubmit = () => {
    segmentEventTracker.trackEvent(TrackEventName.SUBMIT_FOR_VERIFICATION_BUSINESS_CLICKED)
    if (this.incompleteBtp()) return;
    this.props.resolveNotifications('btp', this.props.businessTrustPass.id);
    this.props.submitBusinessTrustpass(
      this.props.user.id,
      this.props.businessTrustPass.id
    );
  }

  isButtonDisabled = () => {
    const { personalTrustPass, businessTrustPass } = this.props;
    const { onboarding } = this.props.user;
    return !onboarding.ptp_submitted ||
      !onboarding.btp_submitted ||
      !personalTrustPass.are_requirements_completed ||
      !businessTrustPass.are_requirements_completed;
  }

  submitButtonClassName = () => {
    return classNames(
      'ds-btn',
      '_outsideCard',
      {'_disabled': this.isButtonDisabled()},
    );
  }

  onSubmit = async () => {
    if (this.isButtonDisabled()) return;

    segmentEventTracker.trackEvent(TrackEventName.SUBMIT_FOR_VERIFICATION_ALL_CLICKED)

    const { push, finishOnboarding } = this.props;

    // We will not require trade docs in onboarding
    // see https://firstcircle.atlassian.net/browse/ORIG-654
    await finishOnboarding();

    push('/');
  }

  onSignOutAction = () => {
    segmentEventTracker.trackEvent(TrackEventName.LOG_OUT_AND_CONTINUE_CLICKED)
    this.props.signOut()
  };

  trackPageView(){
    segmentEventTracker.trackPageView(PageViewName.REQUIREMENTS_PAGE_VIEWED)
  }

  render() {
    if(!this.props.user || !this.props.user.onboarding) return <div />;
    return (
      <Layout
        gridClassName="--narrow _marginTop--xxlarge-tabletUp"
        header={!this.props.user.onboarding_finished ? "Unlock Your Credit Limit" : ''}
        backButtonAction={!this.props.user.onboarding_finished ? () => {this.props.push('/')} : null}
      >
        <div className="ds-cardList">
          <PTPRequirements
            ptp={this.props.personalTrustPass}
            loading={this.props.loading}
            onSubmit={this.onPTPSubmit}
            push={this.props.push}
          />
          <BTPRequirements
            ptp={this.props.personalTrustPass}
            btp={this.props.businessTrustPass}
            loading={this.props.loading}
            onSubmit={this.onBTPSubmit}
            push={this.props.push}
          />
          { !this.props.user.onboarding_finished &&
            <button onClick={this.onSubmit}
                    className={this.submitButtonClassName()}
                    disabled={this.isButtonDisabled()}
                    data-test='submit-verification-all'>
              Submit to Unlock Your Credit Limit
            </button>
          }
        </div>
        { !this.props.user.onboarding_finished &&
          <div className="_textAlign_center _width--full _marginTop--normal">
            <a
              data-test="log-out"
              onClick={this.onSignOutAction}
            >
              Log out and continue later
            </a>
          </div>
        }
      </Layout>
    )
  }
}

// TODO: use latest trustpass store
const mapStateToProps = (state) => {
  return {
    user: state.user,
    modal: state.shared.ui.modal.default,
    loading: state.shared.ui.loading.default,
    businessTrustPass: state.business_trustpass,
    personalTrustPass: state.personal_trustpass,
    financialTrustPass: state.financialTrustpass,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    push:         (url) => dispatch(push(url)),
    signOut:      () => dispatch(signOut()),
    finishOnboarding:      () => dispatch(finishOnboarding()),
    fetchPersonalTrustpasses: (id) => dispatch(fetchPersonalTrustpasses(id)),
    fetchBusinessTrustpasses: (id) => dispatch(fetchBusinessTrustpasses(id)),
    fetchFinancialTrustpass:  (id) => dispatch(fetchFinancialTrustpass(id, () => {})),
    submitPersonalTrustpass: (userId, id) => { dispatch(submitPersonalTrustpass(userId, id)); },
    submitBusinessTrustpass: (userId, id) => { dispatch(submitBusinessTrustpass(userId, id)); },
    submitFinancialTrustpass: () => { dispatch(submitFinancialTrustpass()); },
    resolveNotifications: (type, id) => { dispatch(resolveNotifications(type, id)); },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Requirements);



// WEBPACK FOOTER //
// ./src/features/home/containers/Requirements.js